(() => {
  const selectors = document.querySelectorAll('[data-quantity-selector]');
  if (!selectors.length) return;

  selectors.forEach((selector) => {
    const input = selector.querySelector('.quantity-selector__input');
    const decrease = selector.querySelector('[data-quantity-decrease]');
    const increase = selector.querySelector('[data-quantity-increase]');

    if (!input || !decrease || !increase) return;

    decrease.addEventListener('click', () => {
      const current = Number(input.value) || 1;
      const min = Number(input.min) || 1;
      input.value = Math.max(min, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    increase.addEventListener('click', () => {
      const current = Number(input.value) || 1;
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('input', () => {
      const min = Number(input.min) || 1;

      if (!input.value || Number(input.value) < min) {
        input.value = min;
      }
    });
  });
})();